import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {IOtherDestination} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/IOtherDestination";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetOtherDestinations = (fiscal_registry_id: number | undefined): UseQueryResult<IOtherDestination[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, fiscal_registry_id: number | undefined): Promise<IOtherDestination[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/fiscal_registry/${fiscal_registry_id}/other_destination`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetOtherDestinations", fiscal_registry_id],
        enabled: !!fiscal_registry_id,
        queryFn: () => doGet(selectedCompany?.company_token, fiscal_registry_id),
    })

};

export default useApiGetOtherDestinations